import axios from './axiosInstance';

export const uploadFile = (formData, onUploadProgress) =>
  axios.post('/pinecone/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  });
